import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m22.5 1.567-2.158.24a7.5 7.5 0 0 0-4.475 2.151L6.06 13.765l4.24 4.242L20.109 8.2a7.5 7.5 0 0 0 2.151-4.475ZM6.06 13.765l-3.622-1.208a.75.75 0 0 1-.293-1.241l.232-.232a6 6 0 0 1 6.14-1.45l1.255.418Z"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m6.06 13.765-3.622-1.208a.75.75 0 0 1-.293-1.241l.232-.232a6 6 0 0 1 6.14-1.45l1.255.418Zm4.24 4.242 1.208 3.622a.75.75 0 0 0 1.241.293l.233-.232a6 6 0 0 0 1.449-6.14l-.416-1.25Z"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m10.3 18.007 1.208 3.622a.75.75 0 0 0 1.241.293l.233-.232a6 6 0 0 0 1.449-6.14l-.416-1.25Zm-2.521.531a2.24 2.24 0 0 1-.659 1.591c-.878.878-5.3 2.121-5.3 2.121s1.243-4.425 2.121-5.3a2.25 2.25 0 0 1 1.444-.655"
    }, null, -1)
  ]));
}
const interfaceShareRocket = { render };
export {
  interfaceShareRocket as default,
  render
};
//# sourceMappingURL=interface-share-rocket.svg.js.map
